import React, { FC } from 'react';
import { Result, Button, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { KycCheckReturnType } from '~/hooks/kyc';
import { kyc } from '~/routes';
import { history } from '~/.';

interface Props {
  onClose?: () => void;
  thanks?: boolean; // show result right after kyc started
}

const KycContent: FC<Props & KycCheckReturnType> = (props) => {
  const [t] = useTranslation('kyc');
  const { onClose, thanks, ...kycCheck } = props;

  const goToKycPage = () => {
    history.push(`/${kyc}`);
    onClose?.();
  };

  const goToDashboard = () => {
    history.push('/');
  };

  if (!kycCheck.ready) return <Spin />;
  return kycCheck.isPending ? (
    thanks ? (
      <Result
        status="success"
        title={t('Thank you for company profile completion')}
        subTitle={t(
          'We will review your company profile. We will notify you as soon as your account is upgraded.'
        )}
        extra={
          <Button type="default" onClick={goToDashboard}>
            {t('Go to the dashboard')}
          </Button>
        }
      />
    ) : (
      <Result
        status="info"
        title={t('We are verifying your company right now')}
        subTitle={t(
          'It may take up to 1-2 business days. We will notify you as soon as your company has been verified'
        )}
      />
    )
  ) : !kycCheck.isCompleted ? (
    <Result
      status="warning"
      title={t('Please complete company profile')}
      subTitle={t('Only verified profiles have access to this feature')}
      extra={
        <Button type="primary" onClick={goToKycPage}>
          {t('Upload company documents')}
        </Button>
      }
    />
  ) : null;
};

export default KycContent;
